// extracted by mini-css-extract-plugin
export default {"node":"node_node__dfWT6"};